export default __webpack_public_path__ + "static/media/P104.2.18e7c46f.mp3";